import { z } from 'zod/v3';

// ===== Training Plan Generator DTOs =====

export const TrainingRecommendationSourceSchema = z.enum(['policy', 'scope']);
export type TrainingRecommendationSource = z.infer<typeof TrainingRecommendationSourceSchema>;

export const TrainingRecommendationDTOSchema = z.object({
  name: z.string(),
  description: z.string(),
  required: z.boolean(),
  dueDateDays: z.number(),
  renewalDays: z.number().nullable(),
  relatedControls: z.array(z.string()),
  rationale: z.string(),
  source: TrainingRecommendationSourceSchema,
  sourcePolicyTitle: z.string().nullable(),
});

export type TrainingRecommendationDTO = z.infer<typeof TrainingRecommendationDTOSchema>;

export const GenerateTrainingPlanInputDTOSchema = z.object({
  programId: z.string(),
});

export type GenerateTrainingPlanInputDTO = z.infer<typeof GenerateTrainingPlanInputDTOSchema>;

export const GenerateTrainingPlanOutputDTOSchema = z.object({
  recommendations: z.array(TrainingRecommendationDTOSchema),
});

export type GenerateTrainingPlanOutputDTO = z.infer<typeof GenerateTrainingPlanOutputDTOSchema>;

export const BulkCreateFromPlanInputDTOSchema = z.object({
  recommendations: z.array(
    z.object({
      name: z.string().min(1).max(200),
      description: z.string().max(2000).optional(),
      required: z.boolean().default(true),
      dueDateDays: z.number().int().positive().optional(),
      renewalDays: z.number().int().positive().optional(),
    })
  ),
});

export type BulkCreateFromPlanInputDTO = z.infer<typeof BulkCreateFromPlanInputDTOSchema>;
